"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdFormik = require("cccisd-formik");
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _MessageViewer = _interopRequireDefault(require("../../../../pages/Messaging/MessageViewer"));
var _messageConditionTranslator = _interopRequireDefault(require("../../../../helpers/messageConditionTranslator.js"));
var _withMessageList = _interopRequireDefault(require("../../../../pages/Messaging/withMessageList"));
var _participants = _interopRequireDefault(require("./participants.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var SendMessageNow = /*#__PURE__*/function (_React$Component) {
  function SendMessageNow() {
    var _this;
    _classCallCheck(this, SendMessageNow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SendMessageNow, [].concat(args));
    _defineProperty(_this, "state", {
      loading: true,
      method: undefined,
      recipients: [],
      templateId: -1
    });
    _defineProperty(_this, "getAllRecipients", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var recipients;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _cccisdApollo.client.query({
              query: _this.props.messageQuery || _participants["default"],
              fetchPolicy: 'network-only',
              variables: {
                groupId: _this.props.groupId,
                roleHandle: _this.props.roleHandle,
                deploymentHandle: _this.props.deployment.deploymentHandle
              }
            }).then(function (res) {
              return res.data.roles.anyRoleList.map(function (role) {
                return {
                  pawnId: role.pawn.pawnId,
                  status: role.assignmentProgress.status,
                  user: role.user
                };
              });
            })["catch"](function (err) {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: 'An error occurred.',
                duration: 5000
              });
              console.error(err);
            });
          case 1:
            recipients = _context.v;
            _context.n = 2;
            return _this.setState({
              loading: false,
              recipients: recipients
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "getSelectedRows", function () {
      var selectedRows = _this.props.rtComponent.table.state.selectedRows;
      return selectedRows;
    });
    _defineProperty(_this, "getSelectedRowData", function () {
      var rtState = _this.props.rtComponent.state;
      var tableState = _this.props.rtComponent.table.state;
      return tableState.data.filter(function (row) {
        return tableState.selectedRows.includes(row["".concat(rtState.pawnIdPath, "pawnId")]);
      });
    });
    _defineProperty(_this, "getEligibleRows", function (values) {
      var allRows = _this.getSelectedRowData();
      var method = values.method;
      if (_this.hasRecipientChain(values)) {
        return allRows;
      }
      return allRows.filter(function (row) {
        if (method === 'email') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.email")];
        }
        if (method === 'sms') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.phone")];
        }
        return false;
      });
    });
    _defineProperty(_this, "getAllEligibleRecipients", function (method) {
      return _this.state.recipients.filter(function (r) {
        if (method === 'email') {
          return r.user.email;
        }
        if (method === 'sms') {
          return r.user.phone;
        }
        return false;
      });
    });
    _defineProperty(_this, "getConditionalPawnIdsFromRecipients", function (recipients, condition) {
      if (condition === 'all_respondents') {
        return recipients.map(function (r) {
          return r.pawnId;
        });
      }
      if (condition === 'complete') {
        return recipients.filter(function (r) {
          return r.status === 'Complete';
        }).map(function (r) {
          return r.pawnId;
        });
      }
      if (condition === 'incomplete') {
        return recipients.filter(function (r) {
          return r.status === 'In Progress';
        }).map(function (r) {
          return r.pawnId;
        });
      }
      if (condition === 'not_started') {
        return recipients.filter(function (r) {
          return r.status === null;
        }).map(function (r) {
          return r.pawnId;
        });
      }
      if (condition === 'incomplete_or_not_started') {
        return recipients.filter(function (r) {
          return r.status === 'In Progress' || r.status === null;
        }).map(function (r) {
          return r.pawnId;
        });
      }
      return [];
    });
    _defineProperty(_this, "getPreviewMessageObject", function (values) {
      var msg = _this.props.messageList.find(function (e) {
        return e.messageId === values.template;
      });
      var msgLabel = msg ? msg.settings.label : '';
      var condition = !_this.getSelectedRows().length && msg ? msg.condition : 'scheduled';
      var eligiblePawnIds = _this.getEligibleRows(values).map(function (e) {
        return e["".concat(_this.props.rtComponent.state.pawnIdPath, "pawnId")];
      });
      var selectedRecipients = eligiblePawnIds.length ? eligiblePawnIds : [];
      var conditionalPawnIdsFromAllRecipients = _this.getConditionalPawnIdsFromRecipients(_this.state.recipients, condition);
      var msgObj = {
        condition: 'scheduled',
        messageMethod: values.method,
        category: 'preview',
        recipients: _this.getSelectedRows().length ? selectedRecipients : conditionalPawnIdsFromAllRecipients,
        settings: {
          label: msgLabel,
          recipientsType: 'respondent'
        }
      };
      var messageInfo = values.method === 'email' ? {
        subject: values.subject,
        body: values.body,
        outroLines: values.outroLines,
        actionText: values.actionText,
        actionUrl: values.actionUrl
      } : {
        body: values.body
      };
      msgObj.messageInfo = messageInfo;
      return msgObj;
    });
    _defineProperty(_this, "hasRecipientChain", function (values) {
      var settings = _this.props.deployment.settings;
      var chainPath = values.method === 'email' ? 'chainEmailFromPawn' : 'chainPhoneFromPawn';
      var recipientChain = settings && settings[chainPath];
      return !!recipientChain;
    });
    _defineProperty(_this, "renderSendInfo", function (values, selectedTemplate) {
      var recipients = _this.state.recipients;
      var selectedRows = _this.getSelectedRows();
      var eligibleSelected = _this.getSelectedRowData().filter(function (row) {
        if (values.method === 'email') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.email")];
        }
        if (values.method === 'sms') {
          return row["".concat(_this.props.rtComponent.state.userPath, "user.phone")];
        }
        return false;
      });
      var hasRecipientChain = _this.hasRecipientChain(values);
      var allIneligible = selectedRows.length && !hasRecipientChain ? eligibleSelected.length === 0 : false;
      var conditionName = (0, _messageConditionTranslator["default"])(selectedTemplate.condition);
      var eligibleRecipients = _this.getAllEligibleRecipients(values.method);
      var eligiblePawnIds = !hasRecipientChain ? _this.getConditionalPawnIdsFromRecipients(eligibleRecipients, selectedTemplate.condition) : _this.getConditionalPawnIdsFromRecipients(recipients, selectedTemplate.condition);
      var recipientCount = eligiblePawnIds.length;
      var recipientTotal = _this.state.recipients.length;
      // let sendInfo;
      var sendInfo = selectedRows.length ? "Send to the ".concat(eligibleSelected.length, " ").concat(eligibleSelected.length !== selectedRows.length ? 'eligible' : '', " selected.").concat(selectedRows.length === eligibleSelected.length ? '' : " (".concat(selectedRows.length - eligibleSelected.length, " selected without ").concat(values.method === 'email' ? 'an email address' : 'a phone number', ".)")) : "Send to the ".concat(recipientCount, " ").concat(recipientTotal > recipientCount ? 'eligible' : '', " respondent").concat(recipientCount === 1 ? '' : 's', " ").concat(selectedTemplate.condition === 'all_respondents' ? '' : "meeting condition \"".concat(conditionName, "\"")).concat(recipientTotal === recipientCount ? '' : " (".concat(recipientTotal - recipientCount, " other").concat(recipientTotal - recipientCount > 1 ? 's' : '', " without ").concat(values.method === 'email' ? 'an email address' : 'a phone number', ")."));
      if (allIneligible) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger ".concat(_style["default"].sendInfo),
          role: "alert"
        }, "All selected (", selectedRows.length, ") have an empty", ' ', values.method === 'email' ? 'email address' : 'phone number', ".");
      }
      if (!selectedRows.length && !eligiblePawnIds.length) {
        if (!hasRecipientChain) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "alert alert-danger ".concat(_style["default"].sendInfo),
            role: "alert"
          }, "All respondents ".concat(selectedTemplate.condition === 'all_respondents' ? '' : "meeting condition \"".concat(conditionName, "\""), "\n                     have an empty ").concat(values.method === 'email' ? 'email address' : 'phone number', "."));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger ".concat(_style["default"].sendInfo),
          role: "alert"
        }, "No respondents match the criteria \"".concat(conditionName, "\"."));
      }
      if (hasRecipientChain) {
        sendInfo = selectedRows.length ? "Attempt to send to the ".concat(selectedRows.length, " selected respondents.") : "Attempt to send to ".concat(selectedTemplate.condition === 'all_respondents' ? "all ".concat(recipients.length, " recipient(s)") : "".concat(eligiblePawnIds.length, " recipient(s) meeting condition \"").concat(conditionName, "\""), ".");
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-info ".concat(_style["default"].sendInfo),
        role: "alert"
      }, sendInfo);
    });
    _defineProperty(_this, "hasEligibleRecipients", function (values) {
      var messageList = _this.props.messageList;
      var recipients = _this.state.recipients;
      var method = values.method,
        template = values.template;
      var selectedRows = _this.getSelectedRows();
      var selectedTemplate = messageList.find(function (e) {
        return e.messageId === template;
      });
      var hasRecipientChain = _this.hasRecipientChain(values);
      var eligibleRecipients = _this.getAllEligibleRecipients(values.method);
      var eligiblePawnIds = !hasRecipientChain ? _this.getConditionalPawnIdsFromRecipients(eligibleRecipients, selectedTemplate.condition) : _this.getConditionalPawnIdsFromRecipients(recipients, selectedTemplate.condition);
      if (hasRecipientChain) {
        return selectedRows.length || eligiblePawnIds.length;
      }
      if (selectedRows.length) {
        var eligibleSelected = _this.getSelectedRowData().filter(function (row) {
          if (method === 'email') {
            return row["".concat(_this.props.rtComponent.state.userPath, "user.email")];
          }
          if (method === 'sms') {
            return row["".concat(_this.props.rtComponent.state.userPath, "user.phone")];
          }
          return false;
        });
        return eligibleSelected.length > 0;
      }
      return eligibleRecipients.length > 0;
    });
    /* /////////////////////////////////////////////////////////////////////////
    // FORMIK METHODS /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(values) {
        var formattedValues, response;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              formattedValues = _this.getPreviewMessageObject(values);
              delete formattedValues.category;
              formattedValues.scheduleTime = _momentTimezone["default"].utc().add(20, 'seconds').format();
              _context2.n = 1;
              return _cccisdAxios["default"].post(Boilerplate.route("api.assignmentDeploymentMessage.store", {
                deploymentId: _this.props.match.params.deploymentId
              }), formattedValues);
            case 1:
              response = _context2.v;
              if (!(response.data.status === 'success')) {
                _context2.n = 2;
                break;
              }
              _this.props.closeModal();
              // this.props.reloadCurrentProject();
              return _context2.a(2, (0, _cccisdNotification["default"])({
                type: 'success',
                message: "Successfully scheduled respondent message \"".concat(formattedValues.settings.label, "\"")
              }));
            case 2:
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: "Failed to schedule respondent message \"".concat(formattedValues.settings.label, "\""),
                duration: 5000
              });
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "validate", function (values) {
      var errors = {};
      if (!_this.hasEligibleRecipients(values)) {
        errors._selected = 'All selected are invalid';
      }
      if (values.method === 'email') {
        if (values.actionText && !values.actionUrl) {
          errors.actionUrl = 'You must supply a Button URL if Button Text is provided';
        }
        if (!values.actionText && values.actionUrl) {
          errors.actionText = 'You must supply Button Text if a Button URL is provided';
        }
        if (!values.subject) {
          errors.subject = 'You must supply a Subject';
        }
        if (!values.body && !values.outroLines) {
          errors.body = 'You must supply either Body (upper) or Body (lower)';
          errors.outroLines = 'You must supply either Body (upper) or Body (lower)';
        }
      } else if (!values.body) {
        errors.body = 'You must supply a Body';
      }
      return errors;
    });
    return _this;
  }
  _inherits(SendMessageNow, _React$Component);
  return _createClass(SendMessageNow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.getSelectedRows().length) {
        this.getAllRecipients();
      } else {
        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      var _this2 = this;
      var messageList = this.props.messageList;
      var _this$state = this.state,
        loading = _this$state.loading,
        templateId = _this$state.templateId;
      if (loading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      var respondentConditions = ['all_respondents', 'complete', 'incomplete', 'incomplete_or_not_started', 'not_started', 'on_respondent_complete'];
      var templates = messageList.filter(function (msg) {
        return msg.category === 'TEMPLATE' && respondentConditions.includes(msg.condition);
      });
      var templateOptions = templates.map(function (item) {
        return {
          label: item.settings.label,
          value: item.messageId
        };
      });
      var methodOptions = [{
        label: 'Email Message',
        value: 'email'
      }, {
        label: 'SMS/Text Message',
        value: 'sms'
      }];
      var selectedTemplate = templates.find(function (e) {
        return e.messageId === templateId;
      });
      if (!selectedTemplate && templates.length) {
        selectedTemplate = templates[0];
      }
      var initialValues = {
        method: 'email'
      };
      if (selectedTemplate) {
        initialValues = Object.assign(initialValues, {
          template: selectedTemplate.messageId,
          subject: selectedTemplate.messageInfo.subject || '',
          body: selectedTemplate.messageInfo.body || '',
          outroLines: selectedTemplate.messageInfo.outroLines || '',
          actionText: selectedTemplate.messageInfo.actionText || '',
          actionUrl: selectedTemplate.messageInfo.actionUrl || '',
          method: selectedTemplate.messageMethod
        });
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger",
          role: "alert"
        }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, "There are currently no templates to select.")), /*#__PURE__*/_react["default"].createElement("p", null, "Please request that a translator create a template."));
      }
      var initialMethod = initialValues.method;
      if (this.state.method) {
        if (initialMethod !== this.state.method) {
          initialValues.body = '';
        }
        initialValues.method = this.state.method;
      }
      var sendInfo = this.renderSendInfo(initialValues, selectedTemplate);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: this.onSubmit,
        validate: this.validate,
        render: function render(props) {
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "template",
            component: _cccisdFormik.CccisdSelect,
            label: "Template (by Label): *",
            options: templateOptions,
            onChange: function onChange(e) {
              props.handleChange(e);
              _this2.setState({
                templateId: Number.parseInt(e.target.value, 10)
              });
            }
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "method",
            component: _cccisdFormik.CccisdSelect,
            label: "Message Type:",
            options: methodOptions,
            onChange: function onChange(e) {
              props.handleChange(e);
              if (initialMethod !== e.target.value) {
                _this2.editMessageBlock.setShow(true);
              }
              _this2.setState({
                method: e.target.value
              });
            }
          }), /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
            title: "Edit Message",
            ref: function ref(e) {
              _this2.editMessageBlock = e;
            }
          }, props.values.method === 'email' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "subject",
            component: _cccisdFormik.CccisdInput,
            label: "Subject: *"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "body",
            component: _cccisdFormik.CccisdTextarea,
            label: "Body".concat(props.values.method === 'email' ? ' (upper)' : '', ":").concat(props.values.method === 'sms' ? ' *' : '')
          }), props.values.method === 'email' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "actionText",
            component: _cccisdFormik.CccisdInput,
            label: "Button Text:"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "actionUrl",
            component: _cccisdFormik.CccisdInput,
            label: "Button URL:"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "outroLines",
            component: _cccisdFormik.CccisdTextarea,
            label: "Body (lower):"
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].subNote
          }, "Note: To place the Data Collection Wave link in the message, type", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%URL%"), " and the link will automatically be filled in when the message is sent. You can also insert", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%firstName%"), ",", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%lastName%"), ", or", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%fullName%"), "."), !!Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].subNote,
            style: {
              marginTop: '1em'
            }
          }, "To specify the URL of a different deployment, you can use one of the following two forms:", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%dcwURLByHandle:your_custom_handle_here%"), " or", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%dcwURLByEndpoint:your_custom_endpoint_here%"), ". You can specify data starting at the recipient pawn by using a \":\" separated path (e.g.,", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, "%pawn:data:customPawnField%"), ").")), sendInfo, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              className: "btn btn-secondary ".concat(_style["default"].button)
            }, "Preview"),
            title: "Previewing message",
            size: props.values.method && props.values.method.toUpperCase() === 'EMAIL' ? 'large' : 'small'
          }, /*#__PURE__*/_react["default"].createElement(_MessageViewer["default"], {
            messageObject: _this2.getPreviewMessageObject(props.values),
            deployment: _this2.props.deployment
          })), /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary ".concat(_style["default"].button),
            type: "submit",
            disabled: props.isSubmitting
          }, "Send Message (Right Now)"));
        }
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(SendMessageNow, "propTypes", {
  rtComponent: _propTypes["default"].object,
  deployment: _propTypes["default"].object,
  messageList: _propTypes["default"].array,
  groupId: _propTypes["default"].number,
  roleHandle: _propTypes["default"].string,
  // From Modal
  closeModal: _propTypes["default"].func,
  // Required for getDeploymentById to work!
  match: _propTypes["default"].object.isRequired,
  // custom message table query
  messageQuery: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string])
});
_defineProperty(SendMessageNow, "defaultProps", {
  closeModal: function closeModal() {}
});
var _default = exports["default"] = (0, _withMessageList["default"])(SendMessageNow);